import styled from 'styled-components'
import theme from 'theme_'

export const AsideAccountBackBtn = styled.div`
  margin-bottom: ${theme.spacing.sm};
`
